import React from 'react'
import { Link } from 'react-router';
import "../index.css"


function Navbar() {
    return (
        <nav class="navbar navbar-expand-lg bg-body-tertiary border-bottom">
            <div class="container">
                <Link class="navbar-brand" to="/" >
                    <img src='media/logo.svg' alt='logo' style={{ width: "27%" }} />
                </Link>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">

                    <form class="d-flex" role="search">
                        <ul class="navbar-nav mb-lg-0">
                            <li class="nav-item">
                                <Link class="nav-link" aria-current="page" to="/signup">Signup</Link>
                            </li>
                            <li class="nav-item">
                                <Link class="nav-link" aria-current="page"  to="/about">About</Link>
                            </li>
                            <li class="nav-item">
                               <Link class="nav-link" aria-current="page"  to="/product">Product</Link>
                            </li>
                            <li class="nav-item">
                               <Link class="nav-link" aria-current="page"  to="/pricing">Pricing</Link>
                            </li>
                            <li class="nav-item">
                               <Link class="nav-link" aria-current="page"  to="/support">Support</Link>
                            </li>
                        </ul>
                    </form>

                </div>
            </div>
        </nav>
    )
}

export default Navbar;